/* THE BIN ID CO. — Theme JS v3 | binid.com.au */
(function(){
'use strict';

/* Mobile nav */
var burger=document.getElementById('burger');
var menu=document.getElementById('mobileMenu');
if(burger&&menu){
  burger.addEventListener('click',function(){
    var open=menu.classList.toggle('open');
    burger.classList.toggle('open',open);
    document.body.style.overflow=open?'hidden':'';
    burger.setAttribute('aria-expanded',open);
  });
  menu.querySelectorAll('a').forEach(function(a){
    a.addEventListener('click',function(){
      menu.classList.remove('open');
      burger.classList.remove('open');
      document.body.style.overflow='';
    });
  });
}

/* Scroll reveal */
var reveals=document.querySelectorAll('.reveal');
if('IntersectionObserver' in window){
  var obs=new IntersectionObserver(function(entries){
    entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('vis');obs.unobserve(e.target);}});
  },{threshold:0.08});
  reveals.forEach(function(el){obs.observe(el);});
}else{reveals.forEach(function(el){el.classList.add('vis');});}

/* Smooth scroll anchors */
document.querySelectorAll('a[href^="#"]').forEach(function(a){
  a.addEventListener('click',function(e){
    var t=document.querySelector(a.getAttribute('href'));
    if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth',block:'start'});}
  });
});

/* Sticky header shadow */
var hdr=document.querySelector('.site-header');
if(hdr){
  window.addEventListener('scroll',function(){
    hdr.classList.toggle('scrolled',window.scrollY>20);
  },{passive:true});
}

/* Product gallery */
var mainImg=document.getElementById('productMainImg');
document.querySelectorAll('.product-thumb').forEach(function(thumb){
  thumb.addEventListener('click',function(){
    if(mainImg)mainImg.src=thumb.dataset.src||thumb.src;
    document.querySelectorAll('.product-thumb').forEach(function(t){t.classList.remove('active');});
    thumb.classList.add('active');
  });
});

/* Variant → price */
var varSel=document.getElementById('variantSelect');
var priceEl=document.getElementById('productPrice');
if(varSel&&priceEl){
  varSel.addEventListener('change',function(){
    var opt=varSel.options[varSel.selectedIndex];
    if(opt&&opt.dataset.price)priceEl.textContent=opt.dataset.price;
  });
}

/* Cart qty auto-submit */
document.querySelectorAll('.qty-input').forEach(function(inp){
  inp.addEventListener('change',function(){var f=inp.closest('form');if(f)f.submit();});
});

/* Sample form */
var sf=document.getElementById('sampleForm');
var ss=document.getElementById('sampleSuccess');
if(sf&&ss){
  sf.addEventListener('submit',function(e){
    var btn=sf.querySelector('.btn-submit');
    if(btn){btn.disabled=true;btn.textContent='Sending...';}
  });
}

/* Collection filter */
document.querySelectorAll('.filter-btn').forEach(function(btn){
  btn.addEventListener('click',function(){
    document.querySelectorAll('.filter-btn').forEach(function(b){b.classList.remove('active');});
    btn.classList.add('active');
    var type=btn.dataset.type;
    document.querySelectorAll('.prod-card[data-type]').forEach(function(c){
      c.style.display=(!type||type==='all'||c.dataset.type===type)?'':'none';
    });
  });
});

/* Toast */
window.showToast=function(msg,ms){
  var t=document.createElement('div');t.className='toast';t.textContent=msg;
  document.body.appendChild(t);
  requestAnimationFrame(function(){t.classList.add('show');});
  setTimeout(function(){t.classList.remove('show');setTimeout(function(){t.parentNode&&t.parentNode.removeChild(t);},400);},ms||3000);
};

})();

/* ── HERO CAROUSEL ── */
(function () {
  var track = document.getElementById('csTrack');
  if (!track) return;

  var slides = track.querySelectorAll('.cs-slide');
  var dots   = document.querySelectorAll('.cs-dot');
  var prev   = document.getElementById('csPrev');
  var next   = document.getElementById('csNext');
  var numEl  = document.getElementById('csCurrentNum');
  var total  = slides.length;
  var current = 0;
  var timer   = null;
  var interval = 4000; // 4s default — overridden by schema if available

  // Try to read interval from Shopify section settings via data attr
  var wrap = track.closest('[data-interval]');
  if (wrap && wrap.dataset.interval) interval = parseInt(wrap.dataset.interval) * 1000;

  function goTo(n, dir) {
    if (n === current) return;
    var old = current;
    current = (n + total) % total;

    // Exit old slide
    slides[old].classList.add('exit-left');
    slides[old].classList.remove('active');
    setTimeout(function () {
      slides[old].classList.remove('exit-left');
    }, 450);

    // Enter new slide
    slides[current].classList.add('active');
    if (numEl) numEl.textContent = current + 1;

    // Dots
    dots.forEach(function (d, i) {
      d.classList.toggle('dot-active', i === current);
    });

    // Progress bar reset
    resetProgress();
  }

  function goNext() { goTo(current + 1, 1); }
  function goPrev() { goTo(current - 1, -1); }

  // Progress bar
  var progressBar = document.createElement('div');
  progressBar.className = 'cs-progress';
  track.appendChild(progressBar);

  function resetProgress() {
    progressBar.style.transition = 'none';
    progressBar.style.width = '0%';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        progressBar.style.transition = 'width ' + (interval / 1000) + 's linear';
        progressBar.style.width = '100%';
      });
    });
  }

  function startAuto() {
    clearInterval(timer);
    timer = setInterval(goNext, interval);
    resetProgress();
  }

  function stopAuto() {
    clearInterval(timer);
    progressBar.style.transition = 'none';
    progressBar.style.width = '0%';
  }

  // Controls
  if (next) next.addEventListener('click', function () { stopAuto(); goNext(); startAuto(); });
  if (prev) prev.addEventListener('click', function () { stopAuto(); goPrev(); startAuto(); });

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      stopAuto();
      goTo(parseInt(dot.dataset.slide), 0);
      startAuto();
    });
  });

  // Touch swipe
  var startX = 0;
  track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
  track.addEventListener('touchend', function (e) {
    var dx = e.changedTouches[0].clientX - startX;
    if (Math.abs(dx) > 40) {
      stopAuto();
      if (dx < 0) goNext(); else goPrev();
      startAuto();
    }
  }, { passive: true });

  // Keyboard
  document.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') { stopAuto(); goNext(); startAuto(); }
    if (e.key === 'ArrowLeft')  { stopAuto(); goPrev(); startAuto(); }
  });

  // Pause on hover
  track.addEventListener('mouseenter', stopAuto);
  track.addEventListener('mouseleave', startAuto);

  // Init
  startAuto();
})();

/* ── PRODUCT FILTER (collections page) ── */
(function(){
  var btns = document.querySelectorAll('.filter-btn');
  if(!btns.length) return;

  btns.forEach(function(btn){
    btn.addEventListener('click', function(){
      btns.forEach(function(b){
        b.classList.remove('cs-dot-on');
        b.style.background = '';
        b.style.borderColor = '';
        b.style.color = '';
      });
      btn.classList.add('cs-dot-on');
      btn.style.background = '#F9C900';
      btn.style.borderColor = '#F9C900';
      btn.style.color = '#1B5E20';

      var type = btn.dataset.type;

      // Show/hide product cards
      document.querySelectorAll('.prod-card[data-type]').forEach(function(c){
        var show = (!type || type === 'all' || c.dataset.type === type);
        c.style.display = show ? '' : 'none';
      });

      // Show/hide category dividers and their sections
      document.querySelectorAll('.cat-div[data-section]').forEach(function(div){
        var sec = div.dataset.section;
        var show = (!type || type === 'all' || sec === type);
        div.style.display = show ? '' : 'none';
        // Also hide the cat-desc that follows
        var next = div.nextElementSibling;
        if(next && next.classList.contains('cat-desc')) next.style.display = show ? '' : 'none';
      });
    });
  });
})();
